import { render, staticRenderFns } from "./auditRelatedVideoCard.vue?vue&type=template&id=28ad03cb"
import script from "./auditRelatedVideoCard.vue?vue&type=script&lang=js"
export * from "./auditRelatedVideoCard.vue?vue&type=script&lang=js"
import style0 from "./auditRelatedVideoCard.vue?vue&type=style&index=0&id=28ad03cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports